import React, { useState, useEffect, Suspense } from 'react';
import { httpGetCourseDetailsForUser } from '../../../../Hooks/admin/admin.get.hooks';
import { useParams } from 'react-router-dom';
import { FormContainer } from '../../../CreateRoutes/CreateForm.styles';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../../CreateRoutes/CreateForm.styles';
import AuthCheckManager from '../../../../Utils/AuthCheck/ManagerCheck.auth';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../../../Components/PageHelmet/HelmetHelper.component';
const CourseDetails = React.lazy(() => import('./CourseDetails.component'));
import Certificate from './Certificates/CertificateAdminGenerator.component';
import TDGCertificate from './Certificates/TDGCertificateAdmin.component';
import SendReminderEmailButton from './SendReminder/SendReminderEmail';
const DeleteCourseFromUser = React.lazy(
  () => import('./DeleteCourse.component')
);
// Shows the details of a course for a specific user, including the ability to generate certificates and delete the course from the user.
const UserCourseDetails = () => {
  const { id, courseId } = useParams();
  const [user, setUser] = useState(null);
  const [course, setCourse] = useState(null);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const GetInfo = async () => {
      try {
        const res = await httpGetCourseDetailsForUser(id, courseId);
        setUser(res.foundUser || {});
        setCourse(res.course || []);
      } catch (err) {
        setError('An error happened');
      } finally {
        setIsLoading(false);
      }
    };
    GetInfo();
  }, [id, courseId]);

  if (isLoading) {
    return <p>Loading user and courses...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <AuthCheckManager>
        <HelmetHelper
          title="Course details for a user"
          description="Displays contents of a course for a user"
        />
        <FormContainer>
          <Suspense fallback={<p>Loading breadcrumbs...</p>}>
            <BreadCrumbs
              one="User Courses"
              oneLink={`/admin/user/courses/${id}`}
              two="Course Details"
            />
          </Suspense>
          <h2>
            COURSE DETAILS for{' '}
            {user?.firstName + ' ' + user?.lastName || 'Unknown User'}
          </h2>
          <Suspense fallback={<p>Loading course details...</p>}>
            <CourseDetails c={course} />
          </Suspense>
          {course?.complete === false && (
            <SendReminderEmailButton userId={id} courseId={course._id} />
          )}
          <SubmitContainer>
            <TopSubmit>
              {status.length > 0 && <p className="result">{status}</p>}
            </TopSubmit>
            <BottomSubmit>
              {/* Render Certificate only if course and user data are available */}
              <Suspense fallback={<p>Loading certificate generator...</p>}>
                {course?.courseName &&
                  user?.firstName &&
                  !course?.courseName.includes('TDG') && (
                    <>
                      <Certificate
                        name={`${user.firstName} ${user.lastName}`}
                        course={course}
                        userId={user._id}
                        setStatus={setStatus}
                      />
                    </>
                  )}
              </Suspense>

              {/* Render TDGCertificate only if course and user data are available */}
              <Suspense fallback={<p>Loading TDG certificate generator...</p>}>
                {course?.courseName &&
                  user?.firstName &&
                  course?.courseName.includes('TDG') && (
                    <TDGCertificate
                      name={`${user.firstName} ${user.lastName}`}
                      dateCompleted={course.date}
                      expiryDate={course.expiryDate}
                      employer={course.employer}
                      address={course.address}
                      certNumber={course.certNum}
                      courseId={course.courseId}
                      userId={user._id}
                      setStatus={setStatus}
                    />
                  )}
              </Suspense>
              <Suspense fallback={<p>Loading delete course button...</p>}>
                <DeleteCourseFromUser
                  userId={id}
                  courseId={course._id}
                  setStatus={setStatus}
                />
              </Suspense>
            </BottomSubmit>
          </SubmitContainer>
        </FormContainer>
      </AuthCheckManager>
    </>
  );
};

export default UserCourseDetails;
